import { globalTheme } from '@pulsepointinc/bi-components';
import { DsTypography } from '@pulsepointinc/design-system-react';
import MarkdownToJSX from 'markdown-to-jsx';
import type { ComponentProps } from 'react';

export const Markdown: React.FC<ComponentProps<typeof MarkdownToJSX>> = (props) => {
  return (
    <MarkdownToJSX
      {...props}
      options={{
        overrides: {
          p: { component: DsTypography },
          span: { component: DsTypography },
          h1: { component: DsTypography, props: { variant: 'h1' } },
          h2: { component: DsTypography, props: { variant: 'h2' } },
          h3: { component: DsTypography, props: { variant: 'h3' } },
          li: {
            component: ({ children, ...props }) => (
              <li {...props}>
                <DsTypography>{children}</DsTypography>
              </li>
            ),
            props: { style: globalTheme.fonts.plainText },
          },
        },
      }}
    />
  );
};
